import firebase from 'firebase';
import { firebaseApp } from '../../data/config';

export const googleProvider = new firebase.auth.GoogleAuthProvider();

const googleAuth = async (onSuccess, onFail) => {
  try {
    firebaseApp
      .auth()
      .signInWithPopup(googleProvider)
      .then((result) => {
        onSuccess(result.user);
      });
  } catch (error) {
    onFail(error);
  }
};

export default googleAuth;
